/**
 * A unique id that works on every origin the UI is served from.
 *
 * `crypto.randomUUID()` is only available in a secure context (https or localhost), so it is used when it is there
 * and a random id made from the time is used on a plain http host. Do not use it for anything secret.
 */
export function newUniqueId(): string {
    return typeof crypto?.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}
